import React, { type RefObject } from 'react';
import { type ReferenceEmojiObject } from '../ReferenceEmojiPlugin';
import classNames from 'classnames';
import styles from './MenuItemComponent.module.css';

const MenuItemComponent = React.forwardRef<HTMLElement | null, any>(
  function MenuItemComponentWithRef(
    { item: { id, skins } }: { item: ReferenceEmojiObject },
    ref
  ) {
    const { native, shortcodes } = skins[0];

    return (
      <div
        className={styles.searchComponent}
        ref={ref as RefObject<HTMLDivElement>}
      >
        <span className={classNames(`emoji-${id}`, styles.emoji)}>
          {native}
        </span>
        <span className={styles.shortcode}>{shortcodes}</span>
      </div>
    );
  }
);

export default MenuItemComponent;
